import { render } from "./features.vue?vue&type=template&id=712d40f8&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"

import "./features.vue?vue&type=style&index=0&id=712d40f8&lang=less&scoped=true"
import "./features.vue?vue&type=style&index=1&id=712d40f8&lang=less"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712d40f8"]])

export default __exports__